import { useIntl } from '@capsicum/common';
import { usePartnerWalletTokenSummarySection } from '@capsicum/features/wallet/shared';

import { SummarySectionItem } from '../../../ui/wallet-partner-details';
import { SummarySectionWrapper } from '../WalletPartnerDetails.styled';

type BonusAndOnHoldSummarySectionProps = {
	ledgerId: string;
	shortCode: string;
};

export const BonusAndOnHoldSummarySection = ({ ledgerId, shortCode }: BonusAndOnHoldSummarySectionProps) => {
	const { $t } = useIntl();

	const { isLoading, tokenSummary } = usePartnerWalletTokenSummarySection(ledgerId);

	if (isLoading) {
		return (
			<SummarySectionWrapper>
				<SummarySectionItem isFlexDirectionRow isLoading />
			</SummarySectionWrapper>
		);
	}

	return (
		<SummarySectionWrapper>
			<SummarySectionItem
				isFlexDirectionRow
				label={$t('wallet.partnerWallet.sections.bonusAndOnHoldSummary.title')}
				testID="walletPartnerDetails-tokenSummary-inUseAmount"
				tooltipPosition="bottom"
				tooltipText={$t('wallet.partnerWallet.sections.bonusAndOnHoldSummary.tooltipText')}
				tooltipTitle={$t('wallet.partnerWallet.sections.bonusAndOnHoldSummary.tooltipTitle')}
				value={`${tokenSummary?.bonusAndOnHold} ${shortCode}`}
				withTooltip
			/>
		</SummarySectionWrapper>
	);
};
